import React from "react"
import ListItem from "./ListItem"
import {
  MIN_OPPORTUNITIES,
  NOT_ENOUGH_DATA,
} from "@swipesense/compliance-helpers"
import PropTypes from "prop-types"
import { getEntityTypeMapping } from "../../helpers/sharedHelperFunctions"

const ListCardBody = props => {
  let data = props.data.filter(
    el => el.compliance && el.opportunities >= MIN_OPPORTUNITIES
  )

  if (!props.loading && data.length === 0) {
    return (
      <NoResultsBody
        lineOne={["No data found."]}
        lineTwo={["Try a new search or date range."]}
      />
    )
  }

  data = sortedComplianceData(data, props.dataSort)
  const blankItemsNeeded = 5 - data.length

  if (blankItemsNeeded > 0) {
    for (let step = 6 - blankItemsNeeded; step < 6; step++) {
      data.push({
        id: "empty" + step, // To populate the unique key in the data mapping
        index: step,
        compliance: NOT_ENOUGH_DATA,
      })
    }
  }

  const noDataCard =
    !props.loading && blankItemsNeeded === 5 && props.data.length > 0 // if there is truly no data at all, the 'no data' blurb should be surfaced

  if (noDataCard) {
    const pluralChildEntityType = getEntityTypeMapping(
      props.childEntityType
    ).pluralDisplay.toLowerCase()

    return (
      <NoResultsBody
        lineOne={[`No ${pluralChildEntityType} found.`]}
        lineTwo={[`You have no ${pluralChildEntityType} fit for this card.`]}
      />
    )
  } else {
    return (
      <div className="list">
        {data.map((item, i) => {
          return (
            <ListItem
              className="list-item"
              key={item.id}
              index={i + 1}
              itemId={item.id}
              label={item.name}
              compliance={Math.round(item.compliance)}
              {...props}
            />
          )
        })}
      </div>
    )
  }
}

const NoResultsBody = props => {
  const headerMessage = props.lineOne.map((line, index) => (
    <div key={index} xkey={index}>
      {line}
    </div>
  ))
  const message = props.lineTwo.map((line, index) => (
    <div key={index} xkey={index}>
      {line}
    </div>
  ))

  return (
    <div className="container">
      <div className="text-semibold text-medium semi-bold center-text">
        {headerMessage}
      </div>
      <div className="center-text text-grey text-small">{message}</div>
    </div>
  )
}

NoResultsBody.propTypes = {
  lineOne: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  lineTwo: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
}

export const sortedComplianceData = (complianceData, dataSort) => {
  complianceData = complianceData.sort((a, b) => b.compliance - a.compliance)

  if (dataSort === "ASC") {
    complianceData = complianceData
      .filter(row => Math.round(row.compliance) < 50)
      .reverse()
  } else {
    complianceData = complianceData.filter(
      row => Math.round(row.compliance) >= 50
    )
  }

  return complianceData.slice(0, 5)
}

ListCardBody.propTypes = {
  data: PropTypes.array.isRequired,
  dataSort: PropTypes.oneOf(["ASC", "DESC"]).isRequired,
  loading: PropTypes.bool,
  childEntityType: PropTypes.string,
}

ListCardBody.defaultProps = {
  dataSort: "DESC",
}

export default ListCardBody
